import { MaterialTaskSetData, TaskSet } from 'entities/task_set'
import { Badge } from 'react-bootstrap'
import { genTextColor } from 'utils/util'
import { ViewModel } from 'view_models/view_model'

export class TaskSetViewModel extends ViewModel<TaskSet> {
    public data = () => {
        if (this.object.kind === 'MATERIAL') {
            return JSON.parse(this.object.data || '{}') as MaterialTaskSetData
        }
    }

    public completeCount = () => {
        return this.object.tasks!.filter((t) => !!t.completedAt).length
    }

    public completeRate = () => {
        return Math.round((this.completeCount() / (this.object.tasks!.length || 1)) * 100)
    }

    public isCompleted = () => {
        return this.completeRate() === 100
    }
    public userGroup = () => {
        const {fontColor, bgColor} = genTextColor(this.object.userGroup?.name ?? "")
        return <>
            <Badge bg='none' style={{backgroundColor: bgColor, color: fontColor}}  >
                {this.object.userGroup?.name}
            </Badge>
        </>
    }
}
